/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const buttonVariantsStyles: Record<string, SxProps> = {
	inline: {
		color: 'primary.main',
		':hover': {
			color: 'primary.dark',
		},
	},
	containedOnDark: {
		fontFamily: 'GT-America-Condensed, GT-America, Roboto, sans-serif',
		fontWeight: 700,
		textTransform: 'uppercase',
		backgroundColor: 'button.primary',
		color: 'button.contrastText',
		borderWidth: '3px',
		borderStyle: 'solid',
		borderColor: 'button.primary',

		':hover': {
			backgroundColor: 'transparent',
			borderColor: 'button.contrastText',
		},
	},
	outlinedOnDark: {
		fontFamily: 'GT-America-Condensed, GT-America, Roboto, sans-serif',
		fontWeight: 700,
		textTransform: 'uppercase',
		backgroundColor: 'transparent',
		color: 'button.contrastText',
		borderWidth: '3px',
		borderStyle: 'solid',
		borderColor: 'button.contrastText',

		':hover': {
			backgroundColor: '#1E1E1E80',
		},
	},
};
